import { style } from 'typestyle';

const adornment = style({
  display: 'inline-block',
});

export default {
  adornment,
};
